import { render } from "./HorizontalScrollSlider.vue?vue&type=template&id=bdcb9134&ts=true"
import script from "./HorizontalScrollSlider.vue?vue&type=script&lang=ts"
export * from "./HorizontalScrollSlider.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__